// extracted by mini-css-extract-plugin
export default {"road":"Road_road__ODcEX","roadImage":"Road_roadImage__qsHcG","maskot":"Road_maskot__BuKkb"};